// src/pages/file-viewer/ProjectView.jsx
import React, { useState, useRef } from "react";
import { useParams } from "react-router-dom";
// import RightSidebar from "./components/RightSidebar";
// import FileViewer from "./FileViewer"; 
import { FileViewer } from "./FileViewer";


import {
  LayoutDashboard,
  Users,
  FileText,
  Settings,
  Share2,
  Search,
  Zap,
  Ruler,
  Download,
  Filter,
} from "lucide-react";

const ProjectView = () => {
  // const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("Plans");
  const projects = JSON.parse(localStorage.getItem("projects")) || [];

  const { projectId } = useParams();
  function getProjectNameById(projectId) {
    const project = projects.find((p) => p.projectId === projectId);
    return project ? project.name : null;
  }

  // Reference to WebViewer instance
  const webViewerInstanceRef = useRef(null);

  // Provide an initial document - could be from project metadata or fallback placeholder
  const STATIC_IMAGE_URL =
    "/sample-docs/sample.pdf"; // recommended: put sample files in /public/sample-docs/
  // You can also use an online URL or image: "https://example.com/plan.pdf"

  // Called when FileViewer is ready
  const handleViewerReady = (instance) => {
    // store the instance in ref for use by toolbar buttons
    webViewerInstanceRef.current = instance;
    // optional: set default tool
    try {
instance.docViewer.getToolManager().setToolMode("Pan");
    } catch (e) {
      console.warn("Could not set default tool:", e);
    }
  };

  // helper to set tool by string
  const setTool = (toolName) => {
    const inst = webViewerInstanceRef.current;
    if (!inst) {
      console.warn("Viewer not ready.");
      return;
    }

    // Mapping friendly names to WebViewer modes
    const map = {
      pan: "Pan",
      select: "AnnotationEdit",
      line: "AnnotationCreateLine",
      polyline: "AnnotationCreatePolyline",
      freehand: "AnnotationCreateFreeHand",
      text: "AnnotationCreateText",
      measure: "AnnotationCreateDistanceMeasurement", // may require measurement module / license
    };

    

    const mode = map[toolName] || toolName;
    try {
      inst.setToolMode(mode);
    } catch (err) {
      console.error("Failed to set tool mode:", mode, err);
      // fallback: try AnnotationEdit
      inst.setToolMode("AnnotationEdit");
    }
  };

  // TopBarButton component uses setTool onClick
  const TopBarButton = ({ icon: Icon, label, onClick }) => (
    <button
      onClick={onClick}
      className="flex flex-col items-center p-2 rounded-lg text-gray-200 hover:bg-gray-700 transition duration-150"
      title={label}
    >
      <Icon className="w-5 h-5" />
      <span className="text-xs mt-1 hidden sm:block">{label}</span>
    </button>
  );



  // ... LeftSidebar, SidebarItem unchanged (use your existing code) ...
  const SidebarItem = ({ icon: Icon, label, isActive, onClick }) => (
    <button
      onClick={onClick}
      className={`w-full flex items-center p-3 text-sm font-medium transition duration-150 rounded-lg ${
        isActive ? "bg-indigo-700 text-white font-bold" : "hover:bg-gray-800 text-gray-300"
      }`}
    >
      <Icon className="w-5 h-5 mr-3" />
      <span className="truncate">{label}</span>
    </button>
  );

  // TopHeader with tool buttons wired
  const TopHeader = () => (
    <header className="bg-gray-800 text-gray-100 border-b border-gray-700 p-2 flex justify-between items-center shadow-md">
      <div className="flex items-center space-x-4 ml-4">
        <span className="text-xl font-semibold text-indigo-400">Project View</span>
        <div className="hidden md:flex space-x-2 text-sm font-medium">
          <span className="p-2 border-b-2 border-indigo-500 text-indigo-400">
            {getProjectNameById(projectId)}
          </span>
        </div>
      </div>

      <div className="flex space-x-1">
          <TopBarButton icon={Ruler} label="Measure" onClick={() => setTool("measure")} />

        <TopBarButton icon={Search} label="Search" onClick={() => setIsRightSidebarOpen(true)} />
        <TopBarButton icon={Zap} label="Poly" onClick={() => setTool("polyline")} />
        <TopBarButton icon={Ruler} label="Line" onClick={() => setTool("line")} />
        <TopBarButton icon={FileText} label="Select" onClick={() => setTool("select")} />
        <TopBarButton icon={Share2} label="Pan" onClick={() => setTool("pan")} />
      </div>

      <div className="flex items-center space-x-3 mr-4">
        <TopBarButton icon={Settings} label="Settings" />
        <TopBarButton icon={Share2} label="Share" />
        <div className="w-8 h-8 bg-indigo-500 rounded-full text-white flex items-center justify-center font-bold">
          AB
        </div>
      </div>
    </header>
  );

  const LeftSidebar = () => (
    <aside className="w-64 bg-gray-900 border-r border-gray-700 flex flex-col h-full overflow-hidden">
      <div className="flex border-b border-gray-700">
        {["Project", "Plans", "Assemblies"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`p-3 text-sm font-semibold transition duration-150 ${
              activeTab === tab ? "border-b-2 border-indigo-500 text-indigo-400" : "text-gray-400 hover:text-indigo-400"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="p-4 flex-grow overflow-y-auto">
        {activeTab === "Plans" && (
          <div className="space-y-2">
            <SidebarItem icon={FileText} label="T| A-101 - GROUND..." isActive={true} />
            <SidebarItem icon={FileText} label="T| A-102 - FIRST FLOOR..." isActive={false} />
          </div>
        )}

        <div className="mt-8 p-4 bg-gray-800 rounded-lg border border-gray-700">
          <p className="text-sm font-semibold mb-2 text-gray-300">Measurements</p>
          <p className="text-xs text-gray-400">You haven't created any measurements or groups yet.</p>
          <button className="mt-3 w-full text-left text-sm text-indigo-400 hover:text-indigo-300 transition duration-150 flex items-center">
            <Ruler className="w-4 h-4 mr-2" /> Create measurement
          </button>
          <button className="mt-2 w-full text-left text-sm text-indigo-400 hover:text-indigo-300 transition duration-150 flex items-center">
            <Users className="w-4 h-4 mr-2" /> Create group
          </button>
        </div>
      </div>

      <div className="p-3 border-t border-gray-700">
        <input
          type="text"
          placeholder="Search in opened pages"
          className="w-full p-2 bg-gray-700 text-white border border-gray-600 rounded-lg text-sm focus:ring-indigo-500 focus:border-indigo-500"
        />
      </div>
    </aside>
  );

  const MainViewer = () => (
    <main className="flex-grow bg-gray-700 relative overflow-hidden">
      <div className="absolute inset-0 p-4 flex items-stretch">
        <div className="w-full h-full bg-white rounded-xl shadow-2xl overflow-hidden">
          {/* FileViewer will render the WebViewer inside */}
          <FileViewer initialDoc={STATIC_IMAGE_URL} onReady={handleViewerReady} style={{ height: "100%", width: "100%" }} />
        </div>
      </div>

      {/* <button
        onClick={() => setIsRightSidebarOpen(!isRightSidebarOpen)}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-indigo-600 text-white p-2 rounded-l-lg shadow-lg hover:bg-indigo-700 transition z-10"
        title={isRightSidebarOpen ? "Hide Tools" : "Show Tools"}
      >
        {isRightSidebarOpen ? "<" : ">"}
      </button> */}
    </main>
  );

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col font-sans text-gray-100">
      <TopHeader />
      <div className="flex flex-1 overflow-hidden">
        <LeftSidebar />
        <MainViewer />
        {/* <div className={`h-full flex-shrink-0 transition-width duration-300 ${isRightSidebarOpen ? "w-64" : "w-0"}`}>
          {isRightSidebarOpen && <RightSidebar projectId={projectId} />}
        </div> */}
      </div>
    </div>
  );
};

export default ProjectView;
